import React from "react";
import { waUrl } from "../lib/api";

export default function WhatsAppButton() {
    return (
        <a
            href={waUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-cta="cta_floating_whatsapp"
            data-testid="floating-wa-btn"
            className="fixed bottom-6 left-6 z-40 hidden md:inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1FB454] text-white px-5 py-3 rounded-full shadow-2xl transition-transform hover:scale-105 font-semibold text-sm"
            aria-label="Chat Counselor via WhatsApp"
        >
            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
                <path d="M17.6 6.32A7.85 7.85 0 0 0 12.04 4c-4.42 0-8 3.58-8 8 0 1.41.37 2.79 1.07 4L4 20l4.13-1.08A7.96 7.96 0 0 0 12.04 20c4.42 0 8-3.58 8-8 0-2.14-.83-4.15-2.44-5.68zM12.04 18.55c-1.24 0-2.46-.33-3.52-.96l-.25-.15-2.45.64.65-2.39-.16-.25a6.5 6.5 0 0 1-1-3.45c0-3.6 2.93-6.53 6.53-6.53 1.74 0 3.38.68 4.61 1.91a6.48 6.48 0 0 1 1.91 4.62c0 3.59-2.93 6.56-6.32 6.56zm3.59-4.91c-.2-.1-1.17-.58-1.35-.64-.18-.07-.31-.1-.45.1s-.51.64-.62.78c-.11.13-.23.15-.42.05-.2-.1-.83-.31-1.59-.98a5.95 5.95 0 0 1-1.1-1.36c-.11-.2-.01-.3.09-.4.09-.09.2-.23.3-.35.1-.11.13-.2.2-.33.07-.13.04-.25-.02-.35-.05-.1-.45-1.08-.61-1.48-.16-.39-.33-.34-.45-.34-.11-.01-.25-.01-.39-.01-.13 0-.35.05-.54.25s-.71.7-.71 1.7c0 1 .73 1.97.83 2.1.1.13 1.43 2.18 3.47 3.06.48.21.86.34 1.16.43.49.16.93.13 1.28.08.39-.06 1.17-.48 1.34-.94.16-.46.16-.86.12-.94-.05-.08-.18-.13-.38-.23z" />
            </svg>
            Chat Counselor
        </a>
    );
}
